module.exports = __webpack_public_path__ + "img/tidslinjer.6e31b7fe.png";